
import { MediaMatcher } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { Constant } from 'src/app/constant/constant';
import { BannerAdvancedService } from 'src/app/services/banner-advanced.service';
import { BannerService } from 'src/app/services/banner.service';
import { CommonService } from 'src/app/services/common.service';
import { ProductService } from 'src/app/services/product.service';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { ScrollbarComponent } from 'src/app/shared/scrollbar/scrollbar.component';
import { ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { environment } from 'src/environments/environment';
import { filter, takeUntil } from 'rxjs/operators';
import { CatalogPriceRulesService } from 'src/app/services/catalog-price-rules.service';
import { Subject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'calsoft-banner-advanced',
  templateUrl: './banner-advanced.component.html',
  styleUrls: ['./banner-advanced.component.scss']
})
export class BannerAdvancedComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  @ViewChild(ScrollbarComponent, { static: true })
  scrollbar: ScrollbarComponent;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  filterActive: boolean = false;
  sortParam: any = 'id' + ',' + Constant.Dsc;
  mobileQuery = this.mediaMatcher.matchMedia('(max-width: 959px)');
  drawerOpen$ = this.screenSizeService.drawerOpen$;
  drawerOpen = true;
  drawerMode = 'side';
  drawerDisableClose = true;
  chats: any[];
  activeChat: any;
  newMessage: string;
  text: string = 'Save';
  menu: any;
  mediaGallery: any = [];



  public serverPath = environment.commonImageApi + 'slider/';

  public serverPath3 = environment.ImageAPI2;
  newMediaGalleryList: any[];
  resourcePrivilege: any;
  writePermission: any = false;
  deletePermission: any = false;
  firstFormGroup: any;
  constructor(
    private router: Router,
    private cd: ChangeDetectorRef,
    private screenSizeService: ScreenSizeService,
    private mediaMatcher: MediaMatcher,
    private location: Location,
    private snackBar: MatSnackBar,
    private bannerService: BannerAdvancedService,
    private productService: ProductService,
    private commonService: CommonService,
    private _formBuilder: UntypedFormBuilder,
    private catalogPriceRulesService: CatalogPriceRulesService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  private _mobileQueryListener: () => void;

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
      this._onDestroy.next();
      this._onDestroy.complete();
  }

  ngOnInit(): void {
    this.menu = 0;

    this.getResource();
    this.createLayoutForm();
    this.getCategoryList();
    this.categoryYFilter();
    this.getAllCategory();

    console.log(this.firstFormGroup);
  }

  createLayoutForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: new UntypedFormControl(0),
      type: ['type1'],
      image1: ['', [Validators.required]],
      image2: ['', [Validators.required]],
      image3: ['', [Validators.required]],
      image4: ['', [Validators.required]],
      image5: ['', [Validators.required]],
      images: this._formBuilder.array([this.createSilderForm()]),
    });
  }





  createSilderForm(): UntypedFormGroup {
    return this._formBuilder.group({
      id: ['', [Validators.required]],
      value: ['', Validators.required],
      type: ['', [Validators.required]],
      category: new UntypedFormControl(0),
    });
  }

  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.BANNER_ADVANCED)
      .subscribe((data: any) => {
        if (!data.read) {

          this.router.navigate(['/unauthorized'])
        } else {



          this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
          this._mobileQueryListener = () => {
            this.mobileQuery.matches ? this.closeDrawer() : this.openDrawer();
            this.cd.detectChanges();
          };
          this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            filter(() => this.mobileQuery.matches),
            untilDestroyed(this)
          ).subscribe(() => this.closeDrawer());
          this.resourcePrivilege = data;
          this.writePermission = data['create'];

          this.deletePermission = data['delete'];


          this.getSliderData();


        }
      })


  }

  CategoryTypeList: any;
  filteredCategoryTypeList: any;
  protected _onDestroy = new Subject<void>();
  CategoryList: any = [];
  getCategoryList() {
    this.catalogPriceRulesService.fetchAlldropdownValueForRule().subscribe(
      (res) => {
        this.CategoryList = res['category'];
        let object = {
          breadCrumpPath: "Spices",
          categoryId: 0,
          categoryName: "None",
          childCount: 2,
          description: "Spices",
          image: null,
          includeInMenu: "1",
          isActive: "0",
          mega: "false",
          metaDescription: "Spices",
          parentId: "2",
          path: "1062",
          pathValue: "1/2/1062",
          position: 0,
          subcategories: [],
          type: "PARENT"
        }

        this.CategoryList.push(object);

        this.CategoryTypeList = this.CategoryList;
        this.filteredCategoryTypeList = this.CategoryTypeList;
      },
      (error) => { }
    );
  }

  public categoryFilterControl: UntypedFormControl = new UntypedFormControl();
  categoryYFilter() {
    this.categoryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.categoryFilter();
      });
  }

  protected categoryFilter() {
    if (!this.CategoryTypeList) {
      return;
    }
    let search = this.categoryFilterControl.value;
    if (!search) {
      this.filteredCategoryTypeList = this.CategoryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredCategoryTypeList = this.CategoryTypeList.filter(
      (category) => category['categoryName'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllCategory() {
    this.filteredCategoryTypeList = this.CategoryTypeList;
  }



  // getResource() {
  //   this.commonService
  //     .getAllAccessForResource(ResourceAccess.BANNER)
  //     .subscribe((data: any) => {
  //       this.resourcePrivilege = data;
  //     });
  // }


  getResult(event) {

    // this.firstFormGroup.value.image = this.mediaGallery.concat(event.productEntityMediaGallery);

    event.productEntityMediaGallery.forEach(element => {
      var object: any = {};
      object = {
        id: 0,
        value: element['fileName'],
        type: 'Slider',

      };

      (<UntypedFormArray>this.firstFormGroup.get('images')).push(
        this.createSilderForm()
      );

      let index = this.firstFormGroup.value.images.length;

      this.firstFormGroup.value.images[index - 1].id = 0
      this.firstFormGroup.value.images[index - 1].value = object.value
      this.firstFormGroup.value.images[index - 1].type = object.type


    });

    this.firstFormGroup.patchValue(this.firstFormGroup.value);
    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });
    console.log(this.firstFormGroup)
  }



  drawerChange(drawerOpen: boolean) {
    this.screenSizeService.drawerOpen.next(drawerOpen);
  }

  openDrawer() {
    this.screenSizeService.drawerOpen.next(true);
    this.cd.markForCheck();
  }

  closeDrawer() {
    this.screenSizeService.drawerOpen.next(false);
    this.cd.markForCheck();
  }

  scrollToBottom() {
    this.scrollbar.scrollbarRef.getScrollElement().scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }

  menuLink(i) {
    this.menu = i;
    this.scrollToBottom();
    if (this.mobileQuery.matches) {
      this.screenSizeService.drawerOpen.next(false);
    }
  }

  back() {
    this.location.back();
  }

  links: any = [{ value: '0', viewValue: 'Banner' }];

  getSliderData() {
    this.bannerService
      .getSliderData(this.page, this.size, this.sortParam)
      .subscribe(
        (res) => {

          if(!res['empty']){
            this.editBanner(res['content'][0]);
          }else{
          

            if(this.firstFormGroup.value.images[0].id==''){
              (<UntypedFormArray>this.firstFormGroup.get('images')).removeAt(0);

            }
          }
        
          //  this.mediaGallery = res['content'];
        },
        (error) => { }
      );
  }


  editBanner(banner: any) {
    this.firstFormGroup.patchValue({
      id: banner.id,
      image1: banner.image1,
      image2: banner.image2,
      image3: banner.image3,
      operationType: banner.operationType,
      image4: banner.image4,
      image5: banner.image5,
      type: banner.type,
    });
    this.firstFormGroup.setControl(
      'images',
      this.editBannerImage(banner.images)
    );
  }

  editBannerImage(image: any[]): UntypedFormArray {
    const formArray = new UntypedFormArray([]);
    image.forEach((s) => {
      formArray.push(
        this._formBuilder.group({
          id: s.id,
          value: s.value,
          type: s.type,
          category:parseInt(s.category)
        })
      );
    });
    return formArray;
  }

  saveData() {
    this.text = 'Processing';
    this.bannerService.saveBannerData(this.firstFormGroup.value).subscribe(
      (response) => {
        this.text = 'Save';
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.text = 'Save';
          this.getSliderData();
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 500,
          });
        } else {
          this.snackBar.open(response['status_message'], '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500,
          });
        }
      },
      (err) => {
        this.text = 'Save';
      }
    );
  }


  imagesToRemoved: any = [];

  deleteImage(value, index) {
    let smallImage = '/slider/' + value;
    console.log(smallImage)
    this.imagesToRemoved.push(smallImage);

    if (this.firstFormGroup.value.images.length > 0) {
      this.productService.deleteImage(this.imagesToRemoved).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

            this.mediaGallery = this.mediaGallery;
            this.snackBar.open(response['status_message'], '×', {
              panelClass: 'success',
              verticalPosition: 'bottom',
              duration: 500,
            });
            this.text = 'Save';
            let id = this.mediaGallery[index];
            console.log(id);

            (<UntypedFormArray>this.firstFormGroup.get('images')).removeAt(index);

            this.saveData();
          } else {
            this.text = 'Save';
            this.snackBar.open(response['status_message'], '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 500,
            });
          }
        },
        (err) => { }
      );
    }

  }



  layout: any = [
    { viewValue: 'type1', value: 'Type 1' },
    { viewValue: 'type2', value: 'Type 2' },
    { viewValue: 'type3', value: 'Type 3' },
    { viewValue: 'type4', value: 'Type 4' },
    { viewValue: 'type5', value: 'Type 5' },
    { viewValue: 'type6', value: 'Type 6' },
    { viewValue: 'type7', value: 'Type 7' },
    { viewValue: 'type8', value: 'Type 8' },
    { viewValue: 'type9', value: 'Type 9' },
    { viewValue: 'type10', value: 'Type 10' },
    // { viewValue: 'type11', value: 'Type 11' },
    // { viewValue: 'type12', value: 'Type 12' },
    // { viewValue: 'type13', value: 'Type 13' },
    // { viewValue: 'type14', value: 'Type 14' },
    // { viewValue: 'type15', value: 'Type 15' },
    // { viewValue: 'type16', value: 'Type 16' },
    // { viewValue: 'type17', value: 'Type 17' },
    // { viewValue: 'type18', value: 'Type 18' },
    // { viewValue: 'type19', value: 'Type 19' },
    // { viewValue: 'type20', value: 'Type 20' },
    // { viewValue: 'type21', value: 'Type 21' },
  ];

  getResultSingeleImage(event, i) {

    // this.firstFormGroup.value.image = this.mediaGallery.concat(event.productEntityMediaGallery);

    this.firstFormGroup.value[i] =
      event.productEntityMediaGallery[0].fileName;


    this.firstFormGroup.patchValue(this.firstFormGroup.value);

    this.snackBar.open('Image Uploaded Successfully..', '×', {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration: 500,
    });
  }

  update(event, i) {
    this.firstFormGroup.value[i] = '';
    this.firstFormGroup.patchValue(this.firstFormGroup.value);
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
